module.exports = __webpack_public_path__ + "img/sha_03.f779f49b.jpg";